module.exports = __webpack_public_path__ + "img/poly-7.efc86031.png";